import React from 'react';
import { useFieldView } from '../contexts/form-view-context';
import { isInputField } from '../ui/form/types';
import { calculateGridStyles } from '../utils/grid-styles';
export const DefaultFieldLayout = ({ fieldId, ...rest })=>{
    const fieldView = useFieldView(fieldId);
    if (!fieldView) {
        return null;
    }
    const { layout, fieldType } = fieldView;
    const dataHook = `form-field-${isInputField(fieldView) ? fieldView.target : fieldView.id}`;
    const dataAttributes = {
        'data-hook': dataHook,
        'data-field-type': fieldType
    };
    const gridStyles = calculateGridStyles({
        layout
    });
    if ('children' in rest) {
        return /*#__PURE__*/ React.createElement("div", {
            style: gridStyles.container,
            ...dataAttributes
        }, rest.children);
    }
    const { renderLabel, renderInput, renderDescription } = rest;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        style: gridStyles.label
    }, renderLabel()), /*#__PURE__*/ React.createElement("div", {
        style: gridStyles.input,
        ...dataAttributes
    }, renderInput(), renderDescription()));
};

//# sourceMappingURL=default-field-layout.js.map